import { render, staticRenderFns } from "./CommentEmotePlayer.vue?vue&type=template&id=8e065230&scoped=true"
import script from "./CommentEmotePlayer.vue?vue&type=script&lang=ts"
export * from "./CommentEmotePlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e065230",
  null
  
)

export default component.exports